module.exports = __webpack_public_path__ + "media/images/subcity-logo-horizontal-12310a214287db167ad070b8d9113998.svg";